<template>
	<div class="kun_loading12_container">
		<span class="loader"></span>
	</div>
</template>


<script>
	export default {
		name: "kun_loading12",
	}
</script>


<style scoped>
	.kun_loading12_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.loader {
		display: block;
		width: 84px;
		height: 84px;
		position: relative;
	}

	.loader:before , .loader:after {
		content: "";
		position: absolute;
		left: 50%;
		bottom: 0;
		width: 64px;
		height: 64px;
		border-radius: 50%;
		background: #c21f1f;
		transform: translate(-50% , -100%)  scale(0);
		animation: push_401 2s infinite linear;
	}

	.loader:after {
		animation-delay: 1s;
	}

	@keyframes push_401 {
		0% , 50% {
			transform: translate(-50% , 0%)  scale(1)
		}

		100% {
			transform: translate(-50%, -100%) scale(0)
		}
	}
</style>
